module.exports = __webpack_public_path__ + "static/img/11.81789d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/11.png
// module id = XQ8C
// module chunks = 4